import { render, staticRenderFns } from "./CeldaTexto.vue?vue&type=template&id=6d1257d4&scoped=true"
import script from "./CeldaTexto.vue?vue&type=script&lang=js"
export * from "./CeldaTexto.vue?vue&type=script&lang=js"
import style0 from "./CeldaTexto.vue?vue&type=style&index=0&id=6d1257d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1257d4",
  null
  
)

export default component.exports